export const getId = () => {
  return Math.random().toString(32).slice(2, 10);
};

export const isChildElement = (parent: Element | null | undefined, child: Element | null | undefined): boolean => {
  if (!parent || !child) return false;

  let node: (Node & ParentNode) | null = child;
  while (node) {
    if (node === parent) return true;
    node = node.parentNode;
  }
  return false;
};

export const isBrowser = (): boolean => {
  return Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
};

export const isMac = (): boolean => {
  if (!isBrowser()) return false;
  return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
};
